import React, { useContext } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { ArrowBackOutlined, Menu as MenuIcon } from "@mui/icons-material";
import { CreatorContext } from "../../context/CreatorContext";
import { Home, Settings } from "tabler-icons-react";
import fontIcons from "../../assets/font-glyphs/icons.json";

const allIcons = [
	"AntDesign",
	"Entypo",
	"EvilIcons",
	"Feather",
	"FontAwesome",
	"FontAwesome5",
	"Fontisto",
	"Foundation",
	"Ionicons",
	"MaterialCommunityIcons",
	"MaterialIcons",
	"Octicons",
	"SimpleLineIcons",
	"Zocial",
].map((f) => ({ name: f, icons: Object.entries(fontIcons[f]) }));

const ShowcaseTabBar = ({
	logo,
	title,
	showDrawer,
	showArrow,
	hideMenuTitle,
	hideMenuIcon,
}) => {
	const { creator } = useContext(CreatorContext);

	const Icon = React.memo(({ family, name, selected, ...props }) => (
		<span
			style={{
				fontSize: 10,
				fontFamily:
					family === "FontAwesome5"
						? "'FontAwesome5', 'FontAwesome5_Regular', 'FontAwesome5Brands'"
						: family,
				color: !selected
					? creator.navigationTextColor
					: creator.color === creator.navigationColor
					? creator.navigationTextColor
					: creator.color,
				marginTop: (
					hideMenuTitle !== undefined ? !hideMenuTitle : !creator.hideMenuTitle
				)
					? 0
					: 12,
				display: (
					hideMenuTitle !== undefined ? !hideMenuTitle : !creator.hideMenuTitle
				)
					? "inline"
					: "block",
			}}
			{...props}
		>
			{String.fromCodePoint(fontIcons[family][name])}
		</span>
	));

	const getIcon = (family, name, selected) => {
		return <Icon family={family} name={name} selected={selected} />;
	};

	function isLight(color) {
		const hex = color.replace("#", "");
		const r = parseInt(hex.substr(0, 2), 16);
		const g = parseInt(hex.substr(2, 2), 16);
		const b = parseInt(hex.substr(4, 2), 16);
		return r * 0.299 + g * 0.587 + b * 0.114 > 186; // Umbral de luminancia
	}

	return (
		<Box
			sx={{
				height: "100%",
				background: creator.navigationColor,
				display: "flex",
				justifyContent: "space-around",
				alignItems: "center",
				textAlign: "center",
				borderBottomLeftRadius: "26px",
				borderBottomRightRadius: "26px",
				"& *:not(span):not(svg)": {
					fontFamily: creator.fontFamilyCap + "!important",
				},
				borderTop:
					creator.navigationColor === "#ffffff" ? "1px solid #efefef" : "none",
			}}
		>
			{creator.creatorPages
				.sort((a, b) => a.order - b.order)
				.filter((page) => page.visible)
				.filter((_, index) => index < 5)
				.map((page, index) => {
					return (
						<Box
							sx={{
								textAlign: "center",
								backgroundColor:
									creator.color === creator.navigationColor
										? "rgba(0, 0, 0, 0.03)"
										: "transparent",
								borderRadius: "50%",
								marginTop: "-10px",
							}}
							key={page.id}
						>
							{getIcon(page.iconType, page.iconName, index === 0)}

							<Typography
								sx={{
									color:
										index > 0
											? creator.navigationTextColor
											: creator.color === creator.navigationColor
											? creator.navigationTextColor
											: creator.color,
									fontSize: 6,
									fontWeight: "bold",
									textAlign: "center",
									marginTop: "-4px",
									fontFamily: creator.fontFamilyCap + "!important",
									opacity: (
										hideMenuTitle !== undefined
											? !hideMenuTitle
											: !creator.hideMenuTitle
									)
										? 1
										: 0,
								}}
							>
								{page.name}
							</Typography>
						</Box>
					);
				})}
		</Box>
	);
};

export default ShowcaseTabBar;
